import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
export function Guarantee() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-134" data-mp="20meizq13l45g">
      <div className="mx-auto grid max-w-4xl items-center gap-8 rounded-[2rem] border-2 border-brand bg-white p-8 md:grid-cols-[auto_1fr] md:p-12" data-id="element-135" data-mp="24ngk6cekrqa2">
        <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full border-4 border-gold bg-brand text-center md:h-40 md:w-40" data-id="element-136" data-mp="29fhs5m4pmuua">
          <ShieldCheckIcon className="h-10 w-10 text-gold md:h-12 md:w-12" aria-hidden="true" data-id="element-137" data-mp="2jbl41jpd67uf" />
          <span className="mt-1 text-2xl font-black leading-none text-white md:text-3xl" data-id="element-138" data-mp="2obgzuvnwqsyw">7 días</span>
          <span className="text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-139" data-mp="2sdaw8rr2lat9">Garantía</span>
        </div>
        <div className="text-center md:text-left" data-id="element-140" data-mp="txy6ly0wtwje">
          <h2 className="text-2xl font-black uppercase leading-tight text-brand md:text-4xl" data-id="element-141" data-mp="tzizlj7kt7f5">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-4 text-lg text-charcoal" data-id="element-142" data-mp="3smhwkiotbnwh">Abres los tomos. Los aplicas en tu vida y tu cocina.</p>
          <p className="mt-2 text-lg text-charcoal" data-id="element-143" data-mp="3nty8uswevcdy">
            Si en 7 días no sientes que tu hinchazón bajó al menos 50%:
          </p>
          <p className="mt-3 text-xl font-extrabold leading-snug text-brand" data-id="element-144" data-mp="3itaj0ajx51lb">
            <Highlight data-id="element-145" data-mp="3dyddhdlulad6">devolución del 100%</Highlight> sin preguntas, sin drama.
          </p>
          <p className="mt-4 text-sm font-semibold text-muted" data-id="element-146" data-mp="feel29eiem6a">
            Tasa de devoluciones: menos del 0.5%.
          </p>
        </div>
      </div>
    </section>;
}